import { useState } from "react"; 
import "./Cursos.css";
import { useNavigate, Link } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { imagenesCursos } from "../../utils/diccionarioImagenes"; 
import CartModal from "./CartModal"; 
import NotificationModal from "../../components/NotificationModal/NotificationModal";
import svgTituloCursos from "../../assets/cursos/cursos_titulo_pagina.svg";
import ContactForm from "../../secciones/ContactForm/ContactForm";
import { useCartModal } from "../../hooks/useCartModal";
import { getCourseDateLabel, isCourseActive, isCourseUpcoming, scrollToContactForm } from "../../utils/courseStatus";

const formatearFecha = (fechaSql) => {
  if (!fechaSql) return "Próximamente";

  const [year, month, day] = fechaSql.split('-');
  const fecha = new Date(year, month - 1, day);

  const opciones = { 
    day: '2-digit', 
    month: 'long',  
  };

  return fecha.toLocaleDateString('es-ES', opciones);
};

function Cursos({ courses, user, setIsCartOpen, purchasedCourses = [], openLoginModal}) {
  const navigate = useNavigate();
    
  const { modalData, isAuthWarningOpen, handleBuyNow, handleContactAsesor, closeModal, closeAuthWarning } = useCartModal(user);

  if (!courses || courses.length === 0) {
    return <Loader texto="Cargando cursos..." />;
  }

  return (
    <>
      <section className="cursos-section section-green">
        <div className="container">
          <div className="banner-svg-container-start">
            <div className="svg-wrapper">  
               <img src={svgTituloCursos} alt="Cursos" className="img-svg-titulo"  />
            </div>
          </div>

          <div className="cursos-list">
            {courses.map((course) => {
              const visual = imagenesCursos[course.id];
              const bgImage = visual ? visual.desktop : "https://via.placeholder.com/600x400?text=Curso+Nuevo";
              
              // layoutType será 'top-right' o 'bottom-left'
              const layoutType = visual?.layout || 'bottom-left';
              const yaInscrito = purchasedCourses.some(comprado => comprado.id === course.id);
              
              return (
                <div key={course.id} className="curso-item">
                  <div className="curso-card">
                    <img
                      src={bgImage}
                      alt={course.nombre}
                      className="curso-card-img"
                    />
                  
                    {/* 🔥 CAPA DE TEXTO SUPERPUESTA CON CLASES CSS */}
                    <div className={`curso-overlay ${layoutType}`}>
                      <h2 className="curso-title">
                        {course.title}
                      </h2>
                      <p className="curso-desc">
                        {course.description}
                      </p>

                      {/* LAS "PÍLDORAS" DE INFORMACIÓN */}
                      <div className="curso-pills">
                        <span className="curso-pill">
                         {getCourseDateLabel(course, formatearFecha)}
                        </span>
                        <span className="curso-pill">
                          {course.info_duracion} horas
                        </span>
                        <span className="curso-pill">
                          {course.fecha_1_tipo}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* CONTENEDOR DE BOTONES */}
                  <div className="curso-buttons">
                    {yaInscrito ? (
                     <Link
                        to="/mis-cursos"
                        className="button button-main">
                        Ya inscrito
                      </Link>
                    ) : (
                      <button
                        className="button button-main"
                        onClick={() => isCourseActive(course) ? handleBuyNow(course) : scrollToContactForm(course)}
                      >
                        {isCourseActive(course) ? "Comprar" : "Próximamente"}
                      </button>
                    )}
                    {!isCourseUpcoming(course) && (
                      <Link
                        to={`/curso/${course.slug}`}
                        className="button button-main" >
                        Ver más
                      </Link>
                    )}
                    <button
                      className="button button-main"
                      onClick={() => handleContactAsesor(course)}
                    >
                      Asesor
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      
      <ContactForm />

      <CartModal 
        isOpen={modalData.isOpen}
        courseImage={modalData.courseImage}
        subtotal={modalData.subtotal}
        type={modalData.type}
        onClose={closeModal} 
        onGoToCart={() => {
          closeModal(); 
          setIsCartOpen(true); 
        }}
      />

      <NotificationModal
        isOpen={isAuthWarningOpen}
        onClose={closeAuthWarning} 
        title="INICIA SESIÓN PARA ADQUIRIR CURSOS"
        buttonText="Iniciar Sesión"
        onAction={() => {
          closeAuthWarning(); 
          openLoginModal();  
        }}
      />
    </>
  );
}

export default Cursos;
